import { cn } from '@/lib/utils.js';

type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
};

/** Toggle estilo design system (36×20, accent quando ligado). */
export function Switch({
  checked,
  onCheckedChange,
  disabled,
  id,
  'aria-label': ariaLabel,
}: SwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition',
        checked ? 'border-accent bg-accent' : 'border-ha-border2 bg-ha-card2',
        disabled && 'cursor-not-allowed opacity-50',
      )}
      onClick={() => onCheckedChange(!checked)}
    >
      <span
        className={cn(
          'pointer-events-none inline-block h-3.5 w-3.5 rounded-full bg-white shadow-sm transition',
          checked ? 'translate-x-[18px] bg-black' : 'translate-x-0.5',
        )}
      />
    </button>
  );
}
